export const screens = {
  sm: "480px",
  md: "768px",
  xl: "1200px",
  container: "1600px",
  page: "2000px",
};
